import { Button, Modal, RadioButton, TextField } from "@shopify/polaris"
import { useContext, useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { GlobalStateContext } from "./providers/GlobalStateProvider.jsx"
import { useSetSelectedStore } from "../hooks/useFirestoreUserHooks.js"
import { useAuthenticatedFetch } from "../hooks/useAuthenticatedFetch.js"

export const Survey = () => {
	const { state } = useContext(GlobalStateContext)
	const [params] = useSearchParams()
	const [surveyIsOpen, setSurveyIsOpen] = useState(false)
	const [surveyForStore, setSurveyForStore] = useState(null)
	const setSelectedStore = useSetSelectedStore()
	const navigate = useNavigate()
	const authenticatedFetch = useAuthenticatedFetch()

	const [answer1, setAnswer1] = useState(null)
	const [answer1Extra, setAnswer1Extra] = useState("")

	const [answer2, setAnswer2] = useState(null)
	const [answer2Extra, setAnswer2Extra] = useState("")

	const [answer3, setAnswer3] = useState("3")

	useEffect(async () => {
		const surveyParamIsPresent = params.has("survey")
		const surveyStore = params.get("surveyStore")

		if (!surveyParamIsPresent || !surveyStore) return

		if (
			surveyStore &&
			surveyStore !== state.shop &&
			state.stores[surveyStore]
		) {
			await setSelectedStore(state.userId, surveyStore)
			window.location.reload()
		} else {
			setSurveyForStore(surveyStore)
			setSurveyIsOpen(true)
		}
	}, [])

	const onSubmit = () => {
		authenticatedFetch("/api/firestore/saveSurveyAnswers", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				shop: surveyForStore,
				answers: {
					answer1,
					answer1Extra,
					answer2,
					answer2Extra,
					answer3,
				},
			}),
		})
			.then(() => {
				window.location.href = `/?storeOverride=${surveyForStore}&trialOfferAvailable=true`
			})
			.catch((err) => {
				console.error("saveSurveyAnswers catched error", err)
			})
	}

	const formIncomplete =
		answer1 === null || answer2 === null || answer3 === null

	return (
		<Modal
			title="Survey"
			open={surveyIsOpen}
			onClose={() => setSurveyIsOpen(false)}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "0.5rem",
					padding: "1rem",
				}}
			>
				<p
					style={{
						fontSize: "0.9rem",
						lineHeight: "1.1rem",
						color: "#777",
					}}
				>
					We are currently running a survey to help us improve our
					product. Your feedback is important to us.
				</p>

				<p style={{ marginTop: "1.5rem" }}>
					1. What was the main reason you decided to leave?
				</p>

				<RadioButton
					label="Too expensive for my current budget"
					onChange={() => setAnswer1("too_expensive")}
					checked={answer1 === "too_expensive"}
				></RadioButton>
				<RadioButton
					label="Unclear or missing features I need"
					onChange={() => setAnswer1("missing_features")}
					checked={answer1 === "missing_features"}
				></RadioButton>
				<RadioButton
					label="Didn't have time to fully explore"
					onChange={() => setAnswer1("not_enough_time")}
					checked={answer1 === "not_enough_time"}
				></RadioButton>
				<RadioButton
					label="Not the right time for my business"
					onChange={() => setAnswer1("not_right_time")}
					checked={answer1 === "not_right_time"}
				></RadioButton>
				<RadioButton
					label="Found another solution"
					onChange={() => setAnswer1("found_another_solution")}
					checked={answer1 === "found_another_solution"}
				></RadioButton>
				<RadioButton
					label="Other"
					onChange={() => setAnswer1("other")}
					checked={answer1 === "other"}
				></RadioButton>
				<TextField
					label=""
					multiline={true}
					rows={4}
					disabled={answer1 !== "other"}
					value={answer1Extra}
					onChange={(change) => setAnswer1Extra(change)}
				/>

				<p style={{ marginTop: "2rem" }}>
					2. What feature would have convinced you to stay?
				</p>

				<RadioButton
					label="Lower price point"
					onChange={() => setAnswer2("lower_price_point")}
					checked={answer2 === "lower_price_point"}
				></RadioButton>
				<RadioButton
					label="Better onboarding/tutorials"
					onChange={() => setAnswer2("better_tutorials")}
					checked={answer2 === "better_tutorials"}
				></RadioButton>
				<RadioButton
					label="More advanced features"
					onChange={() => setAnswer2("more_advanced_features")}
					checked={answer2 === "more_advanced_features"}
				></RadioButton>
				<RadioButton
					label="Integration with other tools"
					onChange={() => setAnswer2("integration_with_other_tools")}
					checked={answer2 === "integration_with_other_tools"}
				></RadioButton>
				<RadioButton
					label="Not sure"
					onChange={() => setAnswer2("not_sure")}
					checked={answer2 === "not_sure"}
				></RadioButton>
				<RadioButton
					label="Other"
					onChange={() => setAnswer2("other")}
					checked={answer2 === "other"}
				></RadioButton>
				<TextField
					label=""
					multiline={true}
					rows={4}
					disabled={answer2 !== "other"}
					value={answer2Extra}
					onChange={(change) => setAnswer2Extra(change)}
				/>

				<p style={{ marginTop: "2rem" }}>
					3. How likely are you to consider Kopy again in the future?
				</p>

				<div style={{ display: "flex", gap: "0.5rem" }}>
					<div
						onClick={() => setAnswer3("1")}
						style={{
							cursor: "pointer",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							width: "20%",
							border: "1px solid #eee",
							borderColor: answer3 === "1" ? "#526FFB" : "#eee",
							padding: "0.5rem",
							borderRadius: "0.5rem",
							boxShadow:
								"0 1px 1px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.1)",
						}}
					>
						<b>1</b>
						<p style={{ textAlign: "center", fontSize: "0.85rem" }}>
							Very unlikely
						</p>
					</div>
					<div
						onClick={() => setAnswer3("2")}
						style={{
							cursor: "pointer",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							width: "20%",
							border: "1px solid #eee",
							borderColor: answer3 === "2" ? "#526FFB" : "#eee",
							padding: "0.5rem",
							borderRadius: "0.5rem",
							boxShadow:
								"0 1px 1px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.1)",
						}}
					>
						<b>2</b>
						<p style={{ textAlign: "center", fontSize: "0.85rem" }}>
							Unlikely
						</p>
					</div>
					<div
						onClick={() => setAnswer3("3")}
						style={{
							cursor: "pointer",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							width: "20%",
							border: "1px solid #eee",
							borderColor: answer3 === "3" ? "#526FFB" : "#eee",
							padding: "0.5rem",
							borderRadius: "0.5rem",
							boxShadow:
								"0 1px 1px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.1)",
						}}
					>
						<b>3</b>
						<p style={{ textAlign: "center", fontSize: "0.85rem" }}>
							Possible
						</p>
					</div>
					<div
						onClick={() => setAnswer3("4")}
						style={{
							cursor: "pointer",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							width: "20%",
							border: "1px solid #eee",
							borderColor: answer3 === "4" ? "#526FFB" : "#eee",
							padding: "0.5rem",
							borderRadius: "0.5rem",
							boxShadow:
								"0 1px 1px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.1)",
						}}
					>
						<b>4</b>
						<p style={{ textAlign: "center", fontSize: "0.85rem" }}>
							Likely
						</p>
					</div>
					<div
						onClick={() => setAnswer3("5")}
						style={{
							cursor: "pointer",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							width: "20%",
							border: "1px solid #eee",
							borderColor: answer3 === "5" ? "#526FFB" : "#eee",
							padding: "0.5rem",
							borderRadius: "0.5rem",
							boxShadow:
								"0 1px 1px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.1)",
						}}
					>
						<b>5</b>
						<p style={{ textAlign: "center", fontSize: "0.85rem" }}>
							Very likely
						</p>
					</div>
				</div>

				<div style={{ marginTop: "2rem", width: "100%" }}>
					<Button
						fullWidth
						disabled={formIncomplete}
						onClick={onSubmit}
					>
						Submit
					</Button>
				</div>
			</div>
		</Modal>
	)
}
